import { Link } from "react-router-dom";
import { Card, CardBody, Col } from "reactstrap";
import { BorderOpacityTitle, Href } from "../../../Constants/Constants";
import { BorderOpacityData, BorderOpacitySubTitle } from "../../../Data/UiKits/NavigateLinks";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const BorderOpacity = () => {
  return (
    <Col xxl="3" sm="6">
      <Card className="height-equal">
        <CommonCardHeader title={BorderOpacityTitle} span={BorderOpacitySubTitle} />
        <CardBody className="border-opacity-wrapper">
          {BorderOpacityData.map((item, index) => (
            <div className={`border p-2 ${item.class}`} key={index}>
              <Link to={Href}>This is {item.text} primary border</Link>
            </div>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default BorderOpacity;
